import { NgModule, Provider, ModuleWithProviders, InjectionToken, forwardRef } from '@angular/core';

import { FxServicesModule } from './services/fx-services.module';
import { FxComponentsModule } from './components/fx-components.module';
import { FxLayoutsModule } from './layouts/fx-layouts.module';

@NgModule({
  imports: [
    FxServicesModule,
    FxComponentsModule,
    FxLayoutsModule,
   ],
  exports: [
    FxServicesModule,
    FxComponentsModule,
    FxLayoutsModule,
  ]
})
export class FxModule { }
